import React, {useEffect} from 'react';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components'
import { mockMapData } from './utils/data'
import './App.css'
import Map from './components/Map'
import Sidebar from './components/Sidebar'
import GlobalContextProvider from './components/GlobalContext';
import theme from './theme';
import pym from "pym.js";
import './i18n';


function App() {

  useEffect(()=>{
    const pymChild = new pym.Child({polling: 500});
    console.log(pymChild);
  },[]);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <GlobalContextProvider>
          <Wrapper>
            <Sidebar />
            <Map data={mockMapData} />
          </Wrapper>
          <div>
          </div>
        </GlobalContextProvider>
      </ThemeProvider>
    </div>
  );
}

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'PT Sans', sans-serif;
  }
  body {
    margin: 0;
  }

  * {
    font-family: 'PT Sans', sans-serif;
    color: ${({ theme}) => theme.black};
  }
`

const Wrapper = styled.div`
  height: 100%;
`

export default App;
